import { initNotificationCountWebComponent, NotificationCountData } from "./notificationCount";
import { initNotificationCountGroupWebComponent, NotificationCountGroupElement } from "./notificationCountGroup";

initNotificationCountWebComponent();
initNotificationCountGroupWebComponent();

const template = document.createElement("template");
template.innerHTML = `
<style>
div.overlay {
    border: solid 1px #5294d5;
    position: absolute;
    right: 0;
    top: 2em;
    min-width: 10em;
    z-index: 101;
    /*padding: 1em;*/
    background-color: white;
}

</style>
<div class="overlay" style="display: none;">
</div>
`;

export class NotificationOverlayElement extends HTMLElement {
  private _shadowRoot: ShadowRoot;
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.appendChild(template.content.cloneNode(true));
  }

  public set data(data) {
    let container = this._shadowRoot.querySelector(".overlay");
    container.innerHTML = "";
    for (const group of data) {
      let element = (document.createElement("notification-countgroup") as NotificationCountGroupElement);
      if (group.title != null) {
        element.setAttribute("title", group.title);
      }
      element.counts = group.counts;
      container.append(element);
    }
  }

  public toggle() {
    let element = this._shadowRoot.querySelector("div");
    if (element.style.display === "none") {
      element.style.display = "inline-block";
    } else {
      element.style.display = "none";
    }
  }
}
export interface NotificationCountgroupData {
  title?: string;
  counts: NotificationCountData[];
}

export function initNotificationOverlayWebComponent() {
  window.customElements.define("notification-overlay", NotificationOverlayElement);
}
